export default __webpack_public_path__ + "static/132-79744e0c768219f21a44cc69565a7f6e.jpg";